import { Card, Skeleton, message, Row, Col, Tooltip, Switch, Button as AntButton } from "antd";
import { Link, useParams } from "react-router-dom";
import Back from "../../../../assets/icons/LeftBack.svg";
import colors from "../../../../share/constants/constants";
import Button from "../../../../components/common/button";
import {
  approveBusiness,
  enableBusinessMessages,
  getBusinessAnalytics,
  getBusinessById,
  giveFreeAds,
  pauseBusinessSubscription,
  resumeBusinessSubscription,
  generateVendorAccessToken,
} from "../../../../api/business";
import { useEffect, useState } from "react";
import { getPromoCode } from "../../../../api/user";
import DeleteMemberModal from "../../../../components/common/modalMember";
import PromoModal from "../../../../components/common/ModalPromo";
import HorizontalNav from "../../../../components/common/horizontalNav";
import AllServices from "../../home/services";
import PasswordModal from "../../../../components/common/passModal";
import YupupCutModal from "../../../../components/common/cutModal";
import FreeAdsModal from "../../../../components/common/freeAdsModal";
import YupupQuantityModal from "../../../../components/common/quantityModal";
import VendorAppModal from "../../../../components/common/vendorAppModal";
import { fetchPrices } from "../../../../store/slices/priceSlice";
import { useDispatch, useSelector } from "react-redux";
import { InfoCircleOutlined, KeyOutlined } from "@ant-design/icons";
import PasswordResetModal from "../../customer/editCustomer/passwordResetModal";
import { AppstoreOutlined } from "@ant-design/icons";
import PublicProfileTabsSettings from "./PublicProfileTabsSettings";

const BusinessDetail = ({
  member = "lorem ipsum",
  phone = "012312222",
  email = "test@example.com",
}) => {
  let { id } = useParams();

  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addPromo, setAddPromo] = useState(false);
  const [selectedKey, setSelectedKey] = useState("analytics");
  const [approveModal, setApproveModal] = useState(false);
  const [suspendModal, setSuspendModal] = useState(false);
  const [promo, setPromo] = useState();
  const [passModal, setPassModal] = useState(false);
  const [cutModal, setCutModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [adsModalOpen, setAdsModalOpen] = useState(false);
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);
  const [analyticsData, setAnalyticsData] = useState();
  const [onChangeState, setOnChangeState] = useState(false);
  const [quntityModal, setQuntityModal] = useState(false);
  const [priceValue, setPriceValue] = useState();
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [vendorAppModalOpen, setVendorAppModalOpen] = useState(false);
  const [vendorAccessToken, setVendorAccessToken] = useState(null);
  const [vendorRefToken, setVendorRefToken] = useState(null);
  const [vendorUserId, setVendorUserId] = useState(null);
  const [generatingToken, setGeneratingToken] = useState(false);

  const dispatch = useDispatch();

  const priceData = useSelector((state) => {
    return state.price.value;
  });

  const showApproveModal = () => {
    setApproveModal(true);
  };
  const showSubscriptionModal = () => {
    setSubscriptionModalOpen(true);
  };

  const yesSubscriptionHandler = async () => {
    const payload = {
      id: id,
    };
    if (business?.business?.isSubscriptionPaused) {
      const res = await resumeBusinessSubscription(payload);
      if (res) {
        message.success("Subscription resumed successfully!");
        setSubscriptionModalOpen(false);
      }
    } else {
      const res = await pauseBusinessSubscription(payload);
      if (res) {
        message.success("Subscription paused successfully!");
        setSubscriptionModalOpen(false);
      }
    }
    getBusinessDetails(id);
  };

  const approveBusinessAccount = async (isChequePayment) => {
    const payload = {
      isApproved: true,
      promoCode: promo,
    };
    if (isChequePayment) {
      payload.isChequePayment = true;
    }
    if (priceValue) {
      payload.subscriptionPriceId = priceValue;
    }
    const res = await approveBusiness(id, payload);
    if (res) {
      message.success("Approved Successfully!");
    }
    getBusinessDetails(id);
  };

  const updateGiveFreeAds = async (payload) => {
    const res = await giveFreeAds(payload);
    if (res) {
      message.success("Successful");
    }
  };

  const getAnalytics = async () => {
    const res = await getBusinessAnalytics(id);
    if (res) {
      setAnalyticsData(res);
    }
  };

  const showQuantityModal = (data) => {
    setQuntityModal(true);
    // setRender(!render);
  };

  const YesPassClick = () => {
    setPassModal(false);
    // setRender(!render);
  };

  const showPasswordModal = () => {
    setPassModal(true);
  };

  const showCutModal = (data) => {
    setCutModal(true);
    // setRender(!render);
  };

  const YesClickHandler = () => {
    setIsModalOpen(false);
    setAddPromo(true);
    getBusinessDetails(id);
    getPromo();
    // setRender(!render);
    // givePromoCode();
  };

  const YesClick = () => {
    setApproveModal(false);
    approveBusinessAccount(onChangeState, priceValue);
  };

  const NoClick = () => {
    setApproveModal(false);
    setSuspendModal(false);
  };

  const YesAdsClick = () => {
    const payload = {
      businessId: adsModalOpen?.business?._id,
      isFreeAds: true,
    };
    setAdsModalOpen(false);
    updateGiveFreeAds(payload);
  };

  const CancelAdsClick = () => {
    setAdsModalOpen(false);
  };

  const yesSuspendClick = async () => {
    setSuspendModal(false);
    const payload = {
      isSuspended: business?.business?.isSuspended ? false : true,
    };
    const res = await approveBusiness(id, payload);
    if (res) {
      message.success(
        `Vendor ${
          business?.business?.isSuspended ? "Unsuspended" : "Suspended"
        } Successfully!`
      );
    }
    getBusinessDetails(id);
  };

  const NoAdsClick = () => {
    const payload = {
      businessId: adsModalOpen?.business?._id,
    };
    setAdsModalOpen(false);
    updateGiveFreeAds(payload);
  };

  const hideModal = () => {
    setIsModalOpen(false);
    setPassModal(false);
    setCutModal(false);
    setApproveModal(false);
    setSuspendModal(false);
    setAdsModalOpen(false);
    setSubscriptionModalOpen(false);
    setQuntityModal(false);
    setVendorAppModalOpen(false);
    setVendorAccessToken(null);
    getBusinessDetails(id);
  };

  const showModal = (id) => {
    setIsModalOpen(true);
  };

  const getBusinessDetails = async (id) => {
    const res = await getBusinessById(id);
    if (res) {
      setBusiness(res);
      setLoading(false);
    }
  };

  const getPromo = async () => {
    const res = await getPromoCode(id);
    if (res) {
      setPromo(res[0]?.promoCode);
    }
  };

  useEffect(() => {
    setLoading(true);
    getBusinessDetails(id);
    getPromo();
    getAnalytics();
  }, [id]);

  const businessInfo = [
    { label: "First Name", value: business?.owner.firstName },
    { label: "Last Name", value: business?.owner.lastName },
    { label: "Email", value: business?.owner.email },
    { label: "Phone Number", value: business?.owner.phoneNumber },
    { label: "Website", value: business?.business.website || "N/A" },
    { label: "Business Name", value: business?.business.businessName },
    {
      label: (
        <div className="flex items-center justify-start space-x-[8px]">
          <p>Business Type</p>
          {business?.business?.businessDescription ? (
            <Tooltip
              title={business?.business?.businessDescription}
              trigger={"click"}
            >
              <InfoCircleOutlined className="text-[16px] cursor-pointer" />
            </Tooltip>
          ) : (
            ""
          )}
        </div>
      ),
      value: business?.business.businessTypeId.name,
    },
    {
      label: "Business Type Cost ($)",
      value: `$${business?.business.businessTypeId.cost}`,
    },
    { label: "Staff Size", value: business?.business?.staffSize },
    {
      label: "Address",
      value: `${business?.business?.businessAddress}, ${business?.business?.city}, ${business?.business?.state}`,
    },
    {
      label: "Promo Code",
      value: `${promo ? promo : "N/A"}`,
    },
    {
      label: "Total Locations",
      value: `${business?.business?.numberOfLocations || "N/A"}`,
    },
  ];

  const BusinessGrid = (data) => {
    const rows = [];
    const colsPerRow = 4;
    for (let i = 0; i < data.length; i += colsPerRow) {
      const rowItems = data.slice(i, i + colsPerRow);
      const isLastRow = i + colsPerRow >= data.length;
      const colSpan = isLastRow ? 24 / rowItems.length : 6;

      rows.push(
        <Row gutter={16} key={i}>
          {rowItems.map((item, index) => (
            <Col className="gutter-row" span={colSpan} key={index}>
              <Card title={item.label} className="custom-card">
                {item.value}
              </Card>
            </Col>
          ))}
        </Row>
      );
    }

    return (
      <div className="flex flex-col items-start justify-start pt-0 min-w-screen">
        {rows}
      </div>
    );
  };

  const showSuspendModal = () => {
    setSuspendModal(true);
  };
  
  const handleAccessVendorApp = async () => {
    try {
      setGeneratingToken(true);
      const vendorId = business?.business?._id || id;
      const response = await generateVendorAccessToken(vendorId);
      const accToken = localStorage.getItem("accessToken");
      const refToken = localStorage.getItem("refreshToken");
      console.log(accToken, "accToken");
      if (response) {
        // Store the redirectUrl which contains the token
        if (response.redirectUrl) {
          setVendorAccessToken(accToken);
          setVendorRefToken(refToken);
          setVendorAppModalOpen(true);
        } else if (response.accessToken) {
          // Fallback to accessToken if redirectUrl is not available
          setVendorAccessToken(accToken);
          setVendorRefToken(refToken);
          setVendorAppModalOpen(true);
        } else {
          message.error("Invalid token response format");
        }
      } else {
        message.error("Failed to generate access token");
      }
    } catch (error) {
      message.error("Error accessing vendor app");
    } finally {
      setGeneratingToken(false);
    }
  };

  const analyticsInfo = [
    {
      label: "Gross Volume",
      value: analyticsData?.totalGrossVolume?.toFixed(2) ?? 0,
    },
    { label: "Sales", value: analyticsData?.totalSales ?? 0 },
    { label: "Customers", value: analyticsData?.totalCustomers?.length ?? 0 },
    { label: "Appointments", value: analyticsData?.totalAppointments ?? 0 },
    { label: "Payouts", value: analyticsData?.totalPayouts?.toFixed(2) ?? 0 },
  ];

  useEffect(() => {
    dispatch(fetchPrices());
  }, []);

  const handleMessagingToggle = async (id, checked) => {
    const payload = {
      isMessagesEnabled: checked
    }
    const res = await enableBusinessMessages(id, payload)
    if (res) {
      setBusiness({ ...business, business: { ...business?.business, isMessagesEnabled: res?.isMessagesEnabled } });
    }
  };

  return (
    <div className={`${isModalOpen || approveModal ? "blur-sm" : ""}`}>
      <div className="grid gap-2 space-x-2 w-full pr-2">
        <div className="flex pt-3 pl-3 place-content-between">
          <Link to="/main/new-business">
            <div className="flex items-center">
              <div className="w-4.4 m-auto grid justify-center h-auto py-1 rounded-lg bg-primaryPurple cursor-pointer">
                <img src={Back} alt="Edit Icon" className="" />
              </div>
              <span className="text-lg font-bold text-black ml-1">
                New Business Requests
              </span>
            </div>
          </Link>
          <div className="flex items-center">
            <Button
              title={"Reset Password"}
              color={colors.primaryPurple}
              type="link"
              className="!border-primaryPurple w-20 md:w-20 md:ml-4"
              onClick={() => setResetPasswordModal(true)}
              icon={<KeyOutlined />}
              danger
            />
          </div>
          {!loading && business?.business?.isApproved === false ? (
            <div className="flex items-center">
              <Button
                title="Approve"
                color={colors.primaryPurple}
                borderRadius={5}
                className="w-20 md:w-20 xl:w-20 mr-1"
                onClick={showApproveModal}
              />

              <Button
                title="Reject"
                border={colors.primaryPurple}
                borderRadius={5}
                className="!text-primaryPurple !border-primaryPurple w-20 md:w-20 xl:w-20 mr-1"
              />
              {!promo && (
                <Button
                  title="Give Promo Code"
                  color={colors.primaryPurple}
                  onClick={showModal}
                  className={`text-primaryBlue w-20 md:w-20 xl:w-20`}
                />
              )}
            </div>
          ) : (
            <div className="flex justify-between items-center">
              {business?.business?.isApproved === true ? (
                <>
                  {business?.business?.isSubscriptionActive && (
                    <Button
                      title={
                        !business?.business?.isSubscriptionPaused
                          ? "Pause Subscription"
                          : "Resume Subscription"
                      }
                      borderRadius={5}
                      className={
                        business?.business?.isSubscriptionPaused
                          ? "w-20 mr-1 bg-primaryPurple text-white"
                          : "w-20 mr-1 !text-primaryPurple border-primaryPurple"
                      }
                      onClick={showSubscriptionModal}
                    />
                  )}
                  <Button
                    title={
                      business?.business?.isSuspended ? "Unsuspend" : "Suspend"
                    }
                    borderRadius={5}
                    onClick={showSuspendModal}
                    className="!text-white bg-primaryPurple !border-primaryPurple w-20 md:w-20 xl:w-20 mr-2"
                  />
                  <Button
                    title="Approved"
                    borderRadius={5}
                    className="!text-primaryPurple !border-primaryPurple bg-white w-20 md:w-20 xl:w-20"
                  />
                </>
              ) : (
                ""
              )}
            </div>
          )}
        </div>

        <div>
          <Card className="rounded-2xl bg-white xl:relative">
            {loading &&
              !business &&
              [1, 1, 1].map((m, i) => (
                <div className="flex flex-row" key={i}>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                </div>
              ))}
          </Card>

          {!loading && business && BusinessGrid(businessInfo)}

          <div className="flex justify-end mt-2 mb-3 space-x-2">
            <AntButton
              icon={<AppstoreOutlined />}
              onClick={handleAccessVendorApp}
              loading={generatingToken}
              className="bg-primaryPurple !text-white h-5.4 tracking-wider flex items-center"
            >
              Manage Vendor App
            </AntButton>
            <div className="bg-white !text-primaryPurple border-primaryPurple size-fit h-5.4 tracking-wider flex items-center justify-between px-2 rounded gap-2">
              <p className="font-medium">Enable Messaging</p>
              <div>
                <Switch
                  checked={business?.business?.isMessagesEnabled ?? true}
                  onChange={(checked) => handleMessagingToggle(business?.business?._id, checked)}
                  className={`${(business?.business?.isMessagesEnabled ?? true) ? '!bg-primaryPurple' : '!bg-gray-400'}`}
                  style={{
                    backgroundColor: (business?.business?.isMessagesEnabled ?? true) ? '#6B4EFF' : '#9CA3AF',
                  }}
                />
              </div>
            </div>
            <Button
              className="bg-white w-19 !text-primaryPurple border-primaryPurple sm:w-18 h-5.4 tracking-wider"
              title={"Edit YupUp's Cut"}
              borderRadius={5}
              onClick={() => showCutModal(business)}
            />
            <Button
              className="w-19 bg-primaryPurple !text-white !focus:text-white h-5.4 !hover:shadow-none tracking-wider"
              title={"Give Free Ads"}
              borderRadius={5}
              onClick={() => {
                setAdsModalOpen(business);
              }}
            />
            <Button
              className="w-19 bg-primaryPurple !text-white !focus:text-white h-5.4 !hover:shadow-none tracking-wider"
              title={"Max Quantity"}
              borderRadius={5}
              onClick={() => {
                showQuantityModal(business);
              }}
            />
          </div>
          <Card className="mt-2 rounded-2xl mb-2">
            <div className="flex">
              <HorizontalNav selected={(key) => setSelectedKey(key)} />
            </div>
            {selectedKey === "analytics" ? (
              BusinessGrid(analyticsInfo)
            ) : (
              <AllServices />
            )}
          </Card>
          {!loading && business?.business ? (
            <PublicProfileTabsSettings
              businessId={id}
              businessDoc={business.business}
              onSaved={() => getBusinessDetails(id)}
            />
          ) : null}
        </div>
      </div>
      {isModalOpen && (
        <PromoModal
          title="Give Promo Code"
          text="Are you sure you want to Give Promo Code?"
          onCancel={hideModal}
          id={id}
          onOk={YesClickHandler}
        />
      )}
      {passModal && (
        <PasswordModal
          title="Change Password"
          text="Are you sure you want to change password?"
          onCancel={hideModal}
          id={id}
          onOk={YesPassClick}
        />
      )}
      {cutModal && (
        <YupupCutModal
          title="Edit Yupup's Cut"
          onCancel={hideModal}
          data={business}
          id={id}
          onOk={YesPassClick}
        />
      )}
      {approveModal && (
        <DeleteMemberModal
          title="Approve Business"
          text="Are you sure you want to approve this business?"
          promo={
            "If you want to give a discount to this business, please generate a Promo Code first."
          }
          onCancel={NoClick}
          onOk={YesClick}
          onChange={(e) => {
            setOnChangeState(e);
          }}
          chequePayment={true}
          setPriceValue={(e) => {
            setPriceValue(e);
          }}
          priceValue={priceValue}
          priceData={priceData}
          businessDescription={
            "Your selected monthly price will be charged to this vendor every month."
          }
        />
      )}
      {suspendModal && (
        <DeleteMemberModal
          title={`${
            business?.business?.isSuspended ? "Unsuspend" : "Suspend"
          } Vendor`}
          text={`Are you sure you want to ${
            business?.business?.isSuspended ? "Unsuspend" : "suspend"
          } this vendor?`}
          onCancel={NoClick}
          onOk={yesSuspendClick}
        />
      )}
      {subscriptionModalOpen && (
        <DeleteMemberModal
          title={`${
            business?.business?.isSubscriptionPaused ? "Resume" : "Pause"
          } Subscription`}
          text={`Are you sure you want to ${
            business?.business?.isSubscriptionPaused ? "Resume" : "Pause"
          } Subscription for this vendor?`}
          onCancel={hideModal}
          onOk={yesSubscriptionHandler}
        />
      )}
      {adsModalOpen && (
        <FreeAdsModal
          title="Give Free Advertisements"
          text="Are you sure you want to give free advertisements to this business?"
          onCancel={CancelAdsClick}
          onOk={YesAdsClick}
          onNo={NoAdsClick}
        />
      )}
      {quntityModal && (
        <YupupQuantityModal
          title="Edit Max Quantity"
          onCancel={hideModal}
          data={business}
          id={id}
          onOk={YesPassClick}
          getBusinessDetails={getBusinessDetails}
        />
      )}
      {resetPasswordModal && (
        <PasswordResetModal
          data={business?.owner}
          title="Reset Password"
          onCancel={() => setResetPasswordModal(false)}
          onOk={() => setResetPasswordModal(false)}
          />
        )}
      {vendorAppModalOpen && (
        <VendorAppModal
          isOpen={vendorAppModalOpen}
          onCancel={hideModal}
          vendorUrl="https://vendor.yupup.com/login"
          businessId={business?.business?._id || id}
          userId={business?.owner?._id}
          accessToken={vendorAccessToken}
          refreshToken={vendorRefToken}
          email={business?.owner?.email}
        />
      )}
    </div>
  );
};

export default BusinessDetail;
